import React from 'react';

import { H3 } from 'components/typography';

import { ErrorBoundary } from './ErrorBoundary';
import { useLabels } from './i18n/useLabels';

function Placeholder() {
  const labels = useLabels();

  return (
    <div>
      <H3>{labels.placeholderTitle}</H3>
      <p>{labels.placeholderBody}</p>
    </div>
  );
}

export function TemplateCustomizationPage() {
  return (
    <ErrorBoundary>
      <Placeholder />
    </ErrorBoundary>
  );
}
